import {useState,useEffect} from 'react';


export function useMediaQuery(query) {
  const [width,setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize',() => setWidth(window.innerWidth),false);
    return () => {
      window.removeEventListener('resize',() => setWidth(window.innerWidth),false);
    }
  });

  return width <= query;
}
